import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { isEmailUsed, resetIsEmailUsed } from "./is-email-used";

const initialState: RetrievalState<boolean> = { fetching: "idle", data: false };

export const isEmailUsedReducer = createReducer<RetrievalState<boolean>>(initialState, builder => {
  builder.addCase(isEmailUsed.fulfilled, state => {
    return {
      ...state,
      data: true,
      fetching: "success",
    };
  });
  builder.addCase(isEmailUsed.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(isEmailUsed.rejected, (state, { error }) => {
    return {
      ...state,
      ...(error.message === "Request failed with status code 404" && { data: false }),
      fetching: "failed",
    };
  });
  builder.addCase(resetIsEmailUsed, () => {
    return initialState;
  });
});
